var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not_image_warp"},[_c('el-image',{attrs:{"src":require('@/assets/common/no_data.png'),"fit":"scale-down","lazy":""}}),_c('div',{staticClass:"msg_content"},[_vm._v(_vm._s(this.$t("common.noContent")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }